export interface TreatmentFormFields {
	title: string
	description: string
	duration: string
	selectedDiagnose: number[]
	examinationInterval: string
	rejectMilk: boolean
	milkRejectDays: string
}
export interface TreatmentFormValues {
	treatments: TreatmentFormFields[]
}

export const emptyTreatmentField = (): TreatmentFormFields => ({
	title: '',
	description: '',
	duration: '',
	selectedDiagnose: [],
	examinationInterval: '',
	rejectMilk: false,
	milkRejectDays: '',
})
